import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withT } from '~app/core/BundleProvider';
import { registerHotkey, unregisterHotkey } from '~app/core/useGlobalHotkey';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

// import Logging from '~app/core/logging';
// const log = Logging.getLogger('app.components.googledrivefilesave');

class FileSave extends Component {
  static propTypes = {
    handleSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    type: PropTypes.string,
    extension: PropTypes.string,
    defaultFileName: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state.fileName = props.defaultFileName;
  }

  state = {
    fileName: '',
    showError: false,
  };

  hotkeyCb() {
    this.props.onCancel();
  }

  componentDidMount() {
    this.hotkeyId = registerHotkey({
      hotkey: 'Escape',
      callback: () => this.hotkeyCb(),
      event: 'keyup',
      priority: 8,
      stop: true,
    });
  }

  componentWillUnmount() {
    unregisterHotkey(this.hotkeyId);
  }

  handleChange = e => {
    this.setState({ fileName: e.target.value });
  };

  handleSave = () => {
    let fname = this.state.fileName;
    // Remove extra spaces and replace any single space with underscore
    fname = fname.replace(/\s+/g, ' ').trim().replace(/ /g, '_');
    // Validate file name
    let validFilename = /^[\w_@() -][.\w_@() -]*$/.test(fname);
    if (validFilename) {
      if (
        this.props.type !== 'zip' &&
        this.props.extension &&
        !fname.endsWith(this.props.extension)
      ) {
        fname += this.props.extension;
      }
      this.setState({ showError: false });
      this.props.handleSave(fname);
    } else {
      // Notify the user of an invalid file name
      this.setState({ showError: true });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="GoogleDriveFileSave">
        <h1 className="GoogleDriveFileSave__title">{t('choose-file-name')}</h1>
        <input
          className="GoogleDriveFileSave__input"
          onChange={this.handleChange}
          aria-label={t('file-name-input')}
        />
        {this.state.showError && (
          <div className="GoogleDriveFileSave__error">
            {t('invalid-file-name')}
          </div>
        )}
        <div className="GoogleDriveFileSave__button-group">
          <ClickOrEnterDiv
            className="GoogleDriveFileSave__button"
            onClick={this.handleSave}
            disabled={this.state.fileName?.length === 0}
            role="button"
            tabIndex={0}
          >
            {t('ok-button')}
          </ClickOrEnterDiv>
          <ClickOrEnterDiv
            className="GoogleDriveFileSave__button"
            onClick={this.props.onCancel}
            role="button"
            tabIndex={0}
          >
            {t('cancel-button')}
          </ClickOrEnterDiv>
        </div>
      </div>
    );
  }
}

export default withT(FileSave);
